import { createContext, useContext, useEffect, useState } from "react";

import { getSelectData } from "../actions/mainForm";
import { DataContext } from "./DataContext";

export const RouterContext = createContext();
const { Provider } = RouterContext;

const RouterContextProvider = ({ children }) => {
    const { setData } = useContext(DataContext);

    const [item, setItem] = useState({
        email: '',
        username: '',
        loadingSession: true
    });
    const { email } = item;

    useEffect(() => {
        if (email !== '')
            getSelectData(setData, setItem);
    }, [email]);

    return (
        <Provider value={{ item, setItem }}>
            { children }
        </Provider>
    );
};

export default RouterContextProvider;

export const useMyContext = () => useContext(RouterContext);